import { render, staticRenderFns } from "./Bottombar.vue?vue&type=template&id=0cf98fd4&scoped=true"
import script from "./Bottombar.vue?vue&type=script&lang=js"
export * from "./Bottombar.vue?vue&type=script&lang=js"
import style0 from "./Bottombar.vue?vue&type=style&index=0&id=0cf98fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf98fd4",
  null
  
)

export default component.exports